// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const LoginBehaviorSourceSchema = z.enum(['USER','AGENT'] as const);

export type LoginBehaviorSourceType = `${z.infer<typeof LoginBehaviorSourceSchema>}`

export default LoginBehaviorSourceSchema;
